import { CLEAR_ALL, LOGOUT } from '../../../store/Types';
export const ALL_USU_ENTIDADES = 'ALL_USU_ENTIDADES';
export const SELECTS_USU_ENTIDADES = 'SELECTS_USU_ENTIDADES';
export const LOADING_ALL_USU_ENTIDADES = 'LOADING_ALL_USU_ENTIDADES';
export const ACTIVO_ENT_USUARIO = 'ACTIVO_ENT_USUARIO';
export const PARAMS_USU_ENTIDADES = 'PARAMS_USU_ENTIDADES';

const initialState = {
  all: [],
  selects: [],
  pagination: {
    currentPage: 1,
    itemCount: 1,
    itemsPerPage: 50,
    totalItems: 1,
    totalPages: 1,
  },
  loadingAll: false,
  activo: null,
  params: {
    page: 1,
    limit: 50,
  },
};

export const usuEntidadesReducer = (state = initialState, action) => {
  switch (action.type) {
    case ALL_USU_ENTIDADES:
      return {
        ...state,
        all: action.payload.data,
        pagination: action.payload.meta,
      };
    case SELECTS_USU_ENTIDADES:
      return {
        ...state,
        selects: action.payload,
      };
    case LOADING_ALL_USU_ENTIDADES:
      return {
        ...state,
        loadingAll: action.payload,
      };
    case ACTIVO_ENT_USUARIO:
      return {
        ...state,
        activo: action.payload,
      };
    case PARAMS_USU_ENTIDADES:
      return {
        ...state,
        params: action.payload,
      };
    case CLEAR_ALL:
      return {
        ...state,
        ...initialState,
      };
    case LOGOUT:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
